import React from 'react';
import ChevronDownIcon from '../../icons/chevron-down';
import ChevronUpIcon from '../../icons/chevron-up';
import CopyIcon from '../../icons/copy';
import FavoriteActiveIcon from '../../icons/favorite active';
import FavoriteIcon from '../../icons/favorite';


const GeneralProfileSidebarContent = ({
    data,
    activeIdx = [],
    handleListItemClick,
    handlChildrenListItemClick,
    handleLoadMore,
    loadMoreIsVisible,
    handleAccountModalOpen,
    isAccountModalVisible,
    changeFavorite,
}) => {

    const handleFavoriteToggle = (item, event) => {
        event.stopPropagation();
        changeFavorite(item.id);
    }


    return (
        <div className='general_sidebar_content'>
            <div className='general_sidebar_content__title'>
                <h3>PROFILE</h3>
                <h3>TOTAL, $</h3>
            </div>
            <div className='general_sidebar_content__list'>
                {data.map((item, index) => (
                    <div key={index}>
                        <div className='general_sidebar_content__list__info_item'>
                            <div
                                key={item.id}
                                className={activeIdx.includes(item.id) ? 'general_sidebar_content__list__info_item__grid_item active' : 'general_sidebar_content__list__info_item__grid_item'}
                                onClick={() => handleListItemClick(item.id)}>
                                {activeIdx.includes(item.id) ? <ChevronUpIcon /> : <ChevronDownIcon />}

                                <div className='general_sidebar_content__list__info_item__grid_item__icon' onClick={
                                    (event) => handleFavoriteToggle(item, event)
                                }>
                                    {item.isFavorite ? <FavoriteActiveIcon /> :  <FavoriteIcon />}
                                </div>

                                <div className='general_sidebar_content__list__info_item__grid_item__name'>
                                    {item.name}
                                </div>
                                <div className='general_sidebar_content__list__info_item__grid_item__total'>
                                    {item.total}
                                </div>
                            </div>
                            {
                                isAccountModalVisible && (
                                    <div onClick={() => handleAccountModalOpen(item.id)} className='general_sidebar_content__list__info_item__grid_item__icon'>
                                        <CopyIcon />
                                    </div>
                                )
                            }

                        </div>
                        {activeIdx.includes(item.id) && (
                            <div className='general_sidebar_content__list__children'>
                                {item.children.map((child, childIndex) => (
                                    <div key={childIndex}
                                        className='item__children'
                                        onClick={
                                            () => handlChildrenListItemClick(child.name)
                                        }
                                    >
                                        <div className='general_sidebar_content__list__info_item__grid_item__children__name'>
                                            {child.name}
                                        </div>
                                        <div className='general_sidebar_content__list__info_item__grid_item__children__total'>
                                            {child.total}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                ))}
                {loadMoreIsVisible && (
                    <div className='load-more-row'>
                        <button className='load-more-button' onClick={handleLoadMore}>
                            Смотреть дальше
                        </button>
                    </div>
                )}
            </div>

        </div>
    );
};

export default GeneralProfileSidebarContent;